<template>
    <div id="Calculator" class="container rounded">
        <div class="row rounded-top">
        <div class="col">
            {{ translate.inputtext }}
            </div>
        <div class="col input-group mb-1">
            <input class="form-control"
             v-model="mass" type="text" :placeholder="translate.peryear" />
            </div>
        </div>
        <div class="row"><div class="col">{{ translate.requerments }}</div></div>
        <div class="row"><div class="col">{{ result[18] }}</div></div>
        <div class="row">
        <div class="col">{{ translate.resource }}</div>
        <div class="col">{{ translate.count }}</div>
        <div class="col">{{ translate.sum }}</div>
        </div>
        <div class="row">
        <div class="col">{{ translate.placesize }}</div>
        <div class="col">{{ Math.round(result[1]) }} м²</div>
        <div class="col">{{ Math.round(result[9]) }}тг, ${{ Math.round(result[20]) }}
            <div class="row">
                <div class="col">{{ translate.with }}</div>
        </div></div>
        </div>
        <div class="row"><div class="col">{{ translate.firstpay }}</div></div>
        <div class="row">
        <div class="col">{{ translate.plantinbox }}</div>
        <div class="col">{{ result[2] }} {{ translate.pieces }}</div>
        <div class="col">{{ result[10] }}</div>
        </div>
        <div class="row"><div class="col">{{ translate.currentpay }}</div></div>
        <div class="row">
        <div class="col">{{ translate.fisheat }}</div>
        <div class="col">{{ result[3] }} кг.</div>
        <div class="col">{{ result[11] }}</div>
        </div>
        <div class="row">
        <div class="col">{{ translate.fishplant }}</div>
        <div class="col">{{ result[4] }} {{ translate.piecesfry }}</div>
        <div class="col">{{ result[12] }}</div>
        </div>
        <div class="row">
        <div class="col">{{ translate.waterdemand }}</div>
        <div class="col">{{ Math.round(result[5]) }} м³</div>
        <div class="col">{{ result[13] }}</div>
        </div>
        <div class="row">
        <div class="col">{{ translate.watt }}</div>
        <div class="col">{{ result[6] }} кВт</div>
        <div class="col">{{ result[14] }}</div>
        </div>
        <div class="row">
        <div class="col">{{ translate.comsumabllematerial }}</div>
        <div class="col">{{ result[7] }} {{ translate.parts }}</div>
        <div class="col">{{ result[15] }}</div>
        </div>
        <div class="row"><div class="col">{{ translate.economic }}</div></div>
        <div class="row">
        <div class="col">{{ translate.revenue }}</div>
        <div class="col">{{ result[8] }} {{ getExchangeRate() }}</div>
        <div class="col">{{ result[16] }}</div>
        </div>
        <div class="row">
        <div class="col">{{ translate.gross }}</div>
        <div class="col">{{ translate.totalcost }}</div>
        <div class="col">{{ result[17] }}</div>
        </div>
        <div class="row"><div class="col">{{ translate.comment }}</div>
        </div>
        <div class="row rounded-bottom"><div class="col">{{ regionText }}</div></div>
        </div>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      ru: {
        inputtext: 'Введите планируемый объем производства рыб',
        peryear: 'тонн в год',
        requerments: 'Необходимые условия',
        resource: 'Показатель',
        count: 'Количество',
        sum: 'Сумма, тенге',
        size: 'Площадь водоема',
        with: 'из них',
        firstpay: 'Первоначальные затраты',
        ship: 'Лодка резиновая',
        pieces: 'шт.',
        fishitems: 'Рыболовный инвентарь',
        parts: 'комплект.',
        currentpay: 'Текущие затраты',
        fisheat: 'Корма',
        watt: 'Электропотребление',
        fishplant: 'Рыбопосадочный материал',
        economic: 'Экономические расчеты',
        gross: 'Прибыль',
        pertonn: 'тонн по 600 тг/кг',
        revenue: 'Выручка',
        totalcost: 'При себестоимости производства 70%',
        comment: 'Рекомендации по производству рыбной продукции',
        text: '«При планировании прудового хозяйства следует учитывать необходимость проведения земляных работ для улучшения состояния прудов и эффективной работы хозяйства, а также проведение мелиорации для улучшения кормовой базы»',
        aquasize: 'Площадь водной поверхности',
        numbersadkov: 'Количество садков',
        piecesfry: 'шт. молоди',
        trout: '«При выращивании форели в УЗВ следует учитывать тот факт, что товарной (порционной) массы рыба достигает в течение 6 месяцев выращивания, что обуславливает необходимость полицикла. Также выбранная экономическая модель позволяет осуществить значительную экономию первоначальных затрат за счет использования бюджетных материалов, таких как еврокубы, недорогие брезентовые бассейны и прочие подручные материалы. Также отсутствие дорогостоящей системы автоматизации указывает на необходимость использования дополнительного персонала, что чревато, в некоторых случаях, человеческим фактором. Рекомендуется использовать данную систему для подсобного хозяйства или для производства небольшого объёма рыбной продукции»',
        sturgeon: '«При выращивании осетра в УЗВ следует учитывать тот факт, что товарной массы рыба достигает на втором году жизни. Также выбранная экономическая модель позволяет осуществить значительную экономию первоначальных затрат за счет использования бюджетных материалов, таких как еврокубы, недорогие брезентовые бассейны и прочие подручные материалы. Также отсутствие дорогостоящей системы автоматизации указывает на необходимость использования дополнительного персонала, что чревато, в некоторых случаях, человеческим фактором. Рекомендуется использовать данную систему для подсобного хозяйства или для производства небольшого объёма рыбной продукции»',
        carp: '«При выращивании карпа в ОТРХ следует проводить мелиоративные мероприятия с целью увеличения кормовой базы, а следовательно и повышения рыбопродуктивности водоема»',
        mlnlavra: 'млн. личинок',
        comsumabllematerial: 'Расходные материалы',
        peled: '«При выращивании пеляди в ОТРХ следует проводить мелиоративные мероприятия с целью увеличения кормовой базы. Также следует учесть высокий потенциал пеляди при однолетнем нагуле на заморных водоемах»',
        silvercarp: '«При выращивании толстолобика в ОТРХ следует проводить мелиоративные мероприятия с целью увеличения кормовой базы, а следовательно и повышения рыбопродуктивности водоема»',
        whiteamur: '«При выращивании белого амура в ОТРХ следует проводить мелиоративные мероприятия с целью увеличения кормовой базы, а следовательно и повышения рыбопродуктивности водоема»',
        placesize: 'Площадь помещения',
        plantinbox: 'Установка замкнутого водоснабжения в сборе',
        waterdemand: 'Водопотребление',
        africancatfish: '«При выращивании африканского сома в УЗВ следует учитывать тот факт, что товарной массы рыба достигает в течение 6 месяцев выращивания, что обуславливает необходимость полицикла. Также выбранная экономическая модель позволяет осуществить значительную экономию первоначальных затрат за счет использования бюджетных материалов, таких как еврокубы, недорогие брезентовые бассейны и прочие подручные материалы. Также отсутствие дорогостоящей системы автоматизации указывает на необходимость использования дополнительного персонала, что чревато, в некоторых случаях, человеческим фактором. Рекомендуется использовать данную систему для подсобного хозяйства или для производства небольшого объёма рыбной продукции»',
      },
      kz: {
        inputtext: 'Жоспар бойынша өндірілетін балық мөлшерін жазыңыз',
        peryear: 'жылына тонна',
        requerments: 'Қажетті жағдай',
        resource: 'Көрсеткіш',
        count: 'Саны',
        sum: 'Сомасы, теңге',
        size: 'Су айдынының ауданы',
        with: 'оның ішінде',
        firstpay: 'Алғашқы шығындар',
        ship: 'Резеңке қайық',
        pieces: 'дана.',
        fishitems: 'Балық аулайтын құрал-жабдық',
        parts: 'жиынтық',
        currentpay: 'Ағымды шығымдар',
        fisheat: 'Жемдер',
        watt: 'Электр қуатып пайдалану',
        fishplant: 'Отырғызылатын балық материалы',
        economic: 'Экономикалық есептер',
        gross: 'Пайда',
        pertonn: 'тонна 600 тг/кг бойынша',
        revenue: 'Табыс',
        totalcost: 'Өндірістің өзіндік құны 70% болғанда',
        comment: 'Балық өнімін өндіру барысындағы ұсыныстар',
        text: 'Тоған шаруашылығын жоспарлау барысында, шаруашылық жұмысының тиімділігін арттыру үшін және тоғандардың күйін жақсарту үшін жерде жасалатын жұмыстарды орындау қажет, қоректік базаны жақсарту үшін мелиорациялық жұмыстарды жүргізу керек.',
        aquasize: 'Су бетінің  ауданы',
        numbersadkov: 'Шарбақтар саны',
        piecesfry: 'дана. шабақтар',
        trout: 'Бахтах балығын ТСЖ өсіргенде, балық тауарлық (порциндық) салмаққа 6 ай өсірген соң жетеді, ол үшін міндетти түрде полицикл қажет болады. Сонымен қатар таңдалынып алынған экономикалық модель, бюджетті материалдарды дұрыс пайдалану нәтижесінде алғашында жұмсалатын қаржыны айтарлықтай үнемдейді, оларға еврокубтар, арзан березен бассейіндер және басқа да үсақ-түйек заттар жатады.  Қымбат автоматизацияланған жүйелердің жоқтығы, қосымша персоналды тартуды қажет етеді, ол кейде адамдық фактордың туындауына ықпал етеді. Бул жүйені қосалқы шаруашылық құру үшін немесе балық өнімін аз мөлшерде шығару барысында қолдануға болады',
        sturgeon: 'Бекіре балығын ТСЖ өсіру барысында, оның тауарлық салмаққа екінші жылы жететіндігін ескеру керек. Сонымен қатар таңдалынып алынған экономикалық модель, бюджетті материалдарды дұрыс пайдалану нәтижесінде алғашында жұмсалатын қаржыны айтарлықтай үнемдейді, оларға еврокубтар, арзан березен бассейіндер және басқа да үсақ-түйек заттар жатады.  Қымбат автоматизацияланған жүйелердің жоқтығы, қосымша персоналды тартуды қажет етеді, ол кейде адамдық фактордың туындауына ықпал етеді. Бул жүйені қосалқы шаруашылық құру үшін немесе балық өнімін аз мөлшерде шығару барысында қолдануға болады',
        carp: 'Тұқы балығын КТБШ жағдайында өсіру барысында қоректік базаны көбейту мақсатында мелиоративті жұмыстарды жүргізу керек, нәтижесінде су айдынының балық өнімділігі артады',
        mlnlavra: 'слн. Дернәсіл',
        comsumabllematerial: 'Шығыс материалдары',
        peled: 'Ақсаха балығын КТБШ жағдайында өсіру барысында қоректік базаны көбейту мақсатында мелиоративті жұмыстарды жүргізу керек. Сонымен қатар  оттегі тапшы су айдындарында ақсаха балығын бір жаздық жайылымдарда өсірудің жоғары потенциалы бар екендігін де ескеру қажет',
        silvercarp: 'Дөңмаңдай балығын КТБШ жағдайында өсіру барысында қоректік базаны көбейту мақсатында мелиоративті жұмыстарды жүргізу керек, нәтижесінде су айдынының балық өнімділігі артады',
        whiteamur: 'Ақ амурды КТБШ жағдайында өсіру барысында қоректік базаны көбейту мақсатында мелиоративті жұмыстарды жүргізу керек, нәтижесінде су айдынының балық өнімділігі артады',
        placesize: 'Бөлменің ауданы',
        plantinbox: 'Жиналған түйықталған су жүйесі',
        waterdemand: 'Суды пайдалану',
        africancatfish: 'Африкалық жайын балығын ТСЖ өсіргенде, балық тауарлық салмаққа 6 ай өсірген соң жетеді, ол үшін міндетти түрде полицикл қажет болады. Сонымен қатар таңдалынып алынған экономикалық модель, бюджетті материалдарды дұрыс пайдалану нәтижесінде алғашында жұмсалатын қаржыны айтарлықтай үнемдейді, оларға еврокубтар, арзан березен бассейіндер және басқа да үсақ-түйек заттар жатады.  Қымбат автоматизацияланған жүйелердің жоқтығы, қосымша персоналды тартуды қажет етеді, ол кейде адамдық фактордың туындауына ықпал етеді. Бул жүйені қосалқы шаруашылық құру үшін немесе балық өнімін аз мөлшерде шығару барысында қолдануға болады',
      },
      mass: null,
      result: {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
        6: 0,
        7: 0,
        8: 0,
        9: 0,
        10: 0,
        11: 0,
        12: 0,
        13: '0 (при использовании артезианской скважины)',
        14: 0,
        15: 0,
        16: 0,
        17: 0,
        18: '',
        19: 'ссылка на соответствующую область Казахстана',
        20: 0,
      },
    };
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    mass(newMass, oldMass) {
      const { selectedBusiness } = this.$store.state.calc;
      const lang = this.$store.state.calc.currentLocale;
      const aquacultureObject = this.$store.state.calc.selectedAquacultureObject;
      switch (true) {
        case (aquacultureObject === '27.ogg' && selectedBusiness === false):
          this.result = {
            1: newMass * (1000 / 120) * 5,
            2: 1,
            3: newMass * 1000,
            4: 900 * newMass,
            5: newMass * (1000 / 120) * (5 / 33) * 365,
            6: newMass * 14300,
            7: 1,
            8: newMass,
            9: (newMass * 1750000) + (newMass * 700000)
        + (newMass * 900 * 255) + (newMass * 14300 * 19) + (newMass * 100000),
            10: newMass * 1750000,
            11: newMass * 700000,
            12: newMass * 900 * 255,
            13: '0 (при использовании артезианской скважины)',
            14: newMass * 14300 * 19,
            15: newMass * 100000,
            16: newMass * 4500000,
            17: newMass * 4500000 * 0.3,
            18: this[lang].sturgeon,
            19: 'ссылка на соответствующую область Казахстана',
            20: ((newMass * 1750000) + (newMass * 700000)
        + (newMass * 900 * 255) + (newMass * 14300 * 19)
        + (newMass * 100000))
             / this.getUSD(),
          };
          break;
        case (aquacultureObject === '27.ogg' && selectedBusiness === true):
          this.result = {
            1: newMass * (1000 / 120) * 5,
            2: 1,
            3: newMass * 1000,
            4: 800 * newMass,
            5: newMass * (1000 / 120) * (5 / 100) * 365,
            6: newMass * 28600,
            7: 1,
            8: newMass,
            9: (newMass * 5250000) + (newMass * 700000) + (newMass * 800 * 255)
            + (newMass * (1000 / 120) * (5 / 100) * 365 * 52)
            + (newMass * 28600 * 19) + (newMass * 200000),
            10: newMass * 5250000,
            11: newMass * 700000,
            12: newMass * 800 * 255,
            13: Math.round(newMass * (1000 / 120) * (5 / 100) * 365 * 52),
            14: newMass * 28600 * 19,
            15: newMass * 200000,
            16: newMass * 4500000,
            17: newMass * 4500000 * 0.3,
            18: this[lang].sturgeon,
            19: 'ссылка на соответствующую область Казахстана',
            20: ((newMass * 5250000) + (newMass * 700000) + (newMass * 800 * 255)
            + (newMass * (1000 / 120) * (5 / 100) * 365 * 52)
            + (newMass * 28600 * 19) + (newMass * 200000))
             / this.getUSD(),
          };
          break;
        case (aquacultureObject === '23.ogg' && selectedBusiness === false):
          this.result = {
            1: newMass * (1000 / 130) * 5,
            2: 1,
            3: newMass * 1000,
            4: 1450 * newMass,
            5: newMass * (1000 / 130) * (5 / 100) * 365,
            6: newMass * 14300,
            7: 1,
            8: newMass,
            9: (newMass * 1489000) + (newMass * 700000)
            + (newMass * 1450 * 100) + (newMass * 14300 * 19) + (newMass * 100000),
            10: newMass * 1489000,
            11: newMass * 700000,
            12: newMass * 1450 * 100,
            13: '0 (при использовании артезианской скважины)',
            14: newMass * 14300 * 19,
            15: newMass * 100000,
            16: newMass * 1800000,
            17: newMass * 1800000 * 0.3,
            18: this[lang].trout,
            19: 'ссылка на соответствующую область Казахстана',
            20: ((newMass * 1489000) + (newMass * 700000)
            + (newMass * 1450 * 100) + (newMass * 14300 * 19) + (newMass * 100000))
             / this.getUSD(),
          };
          break;
        case (aquacultureObject === '23.ogg' && selectedBusiness === true):
          this.result = {
            1: newMass * (1000 / 130) * 5,
            2: 1,
            3: newMass * 1000,
            4: 1300 * newMass,
            5: newMass * (1000 / 130) * (5 / 100) * 365,
            6: newMass * 28600,
            7: 1,
            8: newMass,
            9: (newMass * 4462000) + (newMass * 700000)
            + (newMass * 1300 * 100)
            + (newMass * (1000 / 130) * (5 / 100) * 365 * 52)
            + (newMass * 28600 * 19),
            10: newMass * 4462000,
            11: newMass * 700000,
            12: newMass * 1300 * 100,
            13: Math.round(newMass * (1000 / 130) * (5 / 100) * 365 * 52),
            14: newMass * 28600 * 19,
            15: newMass * 200000,
            16: newMass * 1800000,
            17: newMass * 1800000 * 0.3,
            18: this[lang].trout,
            19: 'ссылка на соответствующую область Казахстана',
            20: ((newMass * 4462000) + (newMass * 700000)
            + (newMass * 1300 * 100)
            + (newMass * (1000 / 130) * (5 / 100) * 365 * 52)
            + (newMass * 28600 * 19))
             / this.getUSD(),
          };
          break;
        case (aquacultureObject === '32.ogg' && selectedBusiness === false):
          this.result = {
            1: newMass * (1000 / 400) * 4,
            2: 1,
            3: newMass * 700,
            4: 1250 * newMass,
            5: newMass * (1000 / 400) * (4 / 33) * 365,
            6: newMass * 9300,
            7: 1,
            8: newMass,
            9: (newMass * 860000) + (newMass * 490000)
            + (newMass * 1250 * 15) + (newMass * 9300 * 19)
            + (newMass * 50000),
            10: newMass * 860000,
            11: newMass * 490000,
            12: newMass * 1250 * 15,
            13: '0 (при использовании артезианской скважины)',
            14: newMass * 9300 * 19,
            15: newMass * 50000,
            16: newMass * 1000000,
            17: newMass * 1000000 * 0.3,
            18: this[lang].africancatfish,
            19: 'ссылка на соответствующую область Казахстана',
            20: ((newMass * 860000) + (newMass * 490000)
            + (newMass * 1250 * 15) + (newMass * 9300 * 19)
            + (newMass * 50000))
             / this.getUSD(),
          };
          break;
        case (aquacultureObject === '32.ogg' && selectedBusiness === true):
          this.result = {
            1: newMass * (1000 / 400) * 4,
            2: 1,
            3: newMass * 700,
            4: 1100 * newMass,
            5: newMass * (1000 / 400) * (4 / 50) * 365,
            6: newMass * 19500,
            7: 1,
            8: newMass,
            9: (newMass * 1860000) + (newMass * 490000)
            + (newMass * 1100 * 15) + (newMass * (1000 / 400) * (4 / 50) * 365 * 52)
            + (newMass * 19500 * 19) + (newMass * 50000),
            10: newMass * 1860000,
            11: newMass * 490000,
            12: newMass * 1100 * 15,
            13: Math.round(newMass * (1000 / 400) * (4 / 50) * 365 * 52),
            14: newMass * 19500 * 19,
            15: newMass * 50000,
            16: newMass * 1000000,
            17: newMass * 1000000 * 0.3,
            18: this[lang].africancatfish,
            19: 'ссылка на соответствующую область Казахстана',
            20: ((newMass * 1860000) + (newMass * 490000)
            + (newMass * 1100 * 15) + (newMass * (1000 / 400) * (4 / 50) * 365 * 52)
            + (newMass * 19500 * 19) + (newMass * 50000))
             / this.getUSD(),
          };
          break;
        default:
          break;
      }
    },
  },
  created() {
    this.getCurrency();
    this.$say('4.ogg');
  },
  computed: {
    translate() {
      const lang = this.$store.state.calc.currentLocale;
      return this[lang];
    },
    regionText() {
      const lang = this.$store.state.calc.currentLocale;
      const region = this.$store.state.calc.selectedRegion;
      return this.$store.state.calc.textRegion[lang][region];
    },
  },
  methods: {
    ...mapActions('calc', ['getCurrency']),
    translateTonn(item) {
      const lang = this.$store.state.calc.currentLocale;
      if (lang === 'ru') {
        return `тонн по ${item} тг/кг`;
      }
      return `тонна ${item} тг/кг бойынша`;
    },
    getExchangeRate() {
      const aquacultureObject = this.$store.state.calc.selectedAquacultureObject;
      let result;
      if (aquacultureObject === '27.ogg') {
        result = this.translateTonn(4500);
      }
      if (aquacultureObject === '23.ogg') {
        result = this.translateTonn(1800);
      }
      if (aquacultureObject === '32.ogg') {
        result = this.translateTonn(1000);
      }
      return result;
    },
    getGross() {
      const aquacultureObject = this.$store.state.calc.selectedAquacultureObject;
      if (aquacultureObject === 'Карп') {
        return '25%';
      }
      return '40%';
    },
    getMeasure() {
      const aquacultureObject = this.$store.state.calc.selectedAquacultureObject;
      if (aquacultureObject === 'Карп') {
        return 'га';
      }
      return 'м²';
    },
    getUSD() {
      return this.$store.state.calc.USD;
    },
    round_to_precision(x, precision) {
      const y = +x + (precision === undefined ? 0.5 : precision / 2);
      return y - (y % (precision === undefined ? 1 : +precision));
    },
  },


};
</script>
<style scoped>
#Calculator {
    background-color: #22a6de;
    margin: 0 auto;
}
#Calculator div.row {
    border-top: solid #bababa 1px;
    text-align: center;
}
#Calculator div.col {
    border-left: solid #bababa 1px;
    text-align: center;
}
.row {
  flex-wrap: nowrap !important;
}
</style>
